<script setup>
/**
 * FormHistoryBtn
 * Triggers the history/audit log offcanvas for the current record.
 * Only visible if the record has already been persisted (has an ID).
 */
import { computed, getCurrentInstance } from 'vue';
import FormSidebarBtn from "./FormSidebarBtn.vue";
import FormHistoryOffcanvas from "./FormHistoryOffcanvas.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const id = computed(() => store.state[props.formId]?.id);
</script>

<template>
    <div>
        <FormSidebarBtn
            v-if="id"
            data-bs-toggle="offcanvas"
            data-bs-target="#historyOffcanvas"
        >
            <i class="me-2 bi-clock-history"/>
            Open history
        </FormSidebarBtn>

        <FormHistoryOffcanvas :form-id="formId"/>
    </div>
</template>